export const HERO_IMAGE = "/hero.webp";
export const STORY_IMAGE = "/story.webp";
export const CTA_IMAGE = "/cta.webp";
export const BANNER1_IMAGE = "/banner1.webp";
export const BANNER2_IMAGE = "/banner2.webp";

export function downloadICS(content) {
  const start = "20261108T163000";
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Angeo and Gracie//Wedding//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VTIMEZONE",
    "TZID:America/Chicago",
    "BEGIN:STANDARD",
    "DTSTART:20071104T020000",
    "TZOFFSETFROM:-0500",
    "TZOFFSETTO:-0600",
    "TZNAME:CST",
    "END:STANDARD",
    "END:VTIMEZONE",
    "BEGIN:VEVENT",
    "UID:angeo-gracie-wedding-2026@basson",
    "SUMMARY:Angeo & Gracie's Wedding",
    "DTSTART;TZID=America/Chicago:" + start,
    "LOCATION:880 Cherry Springs Dr, Tahlequah, OK 74464",
    "DESCRIPTION:Guests seated for ceremony by 4:30 PM. Formal attire.",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "angeo-and-gracie-wedding.ics";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Apple Maps + calendar use Cherry Springs Dr; Google Maps uses E Cherrie St
export const APPLE_MAPS_URL =
  "https://maps.apple.com/?q=880+Cherry+Springs+Dr,+Tahlequah,+OK+74464";
export const GOOGLE_MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=880+E+Cherrie+St+Tahlequah+OK+74464";
